import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

export default class UpdateYoutubeSlider extends Component {
  state = {
    id: "",
    title: "",
    youtube_id: "",
    loading: true,
    notification: false,
    noticolor: "success",
    message: "",
    redirect: false,
  };

  componentDidMount() {
    if (init() !== "success") {
      this.setState({ redirect: true });
      return;
    }

    // ✅ Get ID from URL
    const pathArr = window.location.pathname.split("/");
    const id = pathArr[2];

    console.log(id);

    if (!id) {
      this.setState({
        notification: true,
        noticolor: "error",
        message: "Invalid Youtube Slider ID",
        loading: false,
      });
      return;
    }
    this.setState({ id }, this.getSingleYoutubeSlider);
  }

  // 🔹 Fetch single youtube slider
  getSingleYoutubeSlider = () => {
    axios
      .get(Constants.getUrls.getAllYoutubeSlider + "/" + this.state.id)
      .then((resp) => {
        if (resp.data.status === "success") {
          const data = resp.data.data;
          this.setState({
            title: data.title || "",
            youtube_id: data.youtube_id || "",
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            noticolor: "error",
            message: resp.data.message,
            loading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: "Failed to load Youtube Slider",
          loading: false,
        });
      });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleUpdate = () => {
    const { id, title, youtube_id } = this.state;

    if (!youtube_id) {
      this.setState({
        notification: true,
        noticolor: "error",
        message: "Youtube ID is required",
      });
      return;
    }

    const payload = {
      title,
      youtube_id,
    };

    axios
      .put(Constants.putUrls.updateYoutubeSlider + id, payload)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            notification: true,
            noticolor: "success",
            message: resp.data.message,
          });

          setTimeout(() => {
            this.setState({ redirect: true });
          }, 1500);
        } else {
          this.setState({
            notification: true,
            noticolor: "error",
            message: resp.data.message,
          });
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err.response?.data?.message || "Update failed",
        });
      });
  };

  render() {
    const { redirect, loading, title, youtube_id, notification, noticolor, message } = this.state;

    if (redirect) {
      return <Navigate to="/youtubeslider" replace />;
    }

    if (loading) {
      return (
        <DashboardLayout>
          <DashboardNavbar />
          <MDBox p={3}>
            <MDTypography>Loading...</MDTypography>
          </MDBox>
        </DashboardLayout>
      );
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Youtube Slider
              </MDTypography>
            </MDBox>

            <MDBox p={3}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Title (optional)"
                    name="title"
                    value={title}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="Youtube Video ID"
                    name="youtube_id"
                    helperText="Example: dQw4w9WgXcQ"
                    value={youtube_id}
                    onChange={this.handleChange}
                  />
                </Grid>

                {/* 🎥 Thumbnail Preview */}
                {youtube_id && (
                  <Grid item xs={12}>
                    <img
                      src={`https://img.youtube.com/vi/${youtube_id}/mqdefault.jpg`}
                      alt="thumbnail"
                      height="120"
                      style={{ borderRadius: "8px" }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} align="right">
                  <MDButton variant="contained" color="info" onClick={this.handleUpdate}>
                    Update
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Card>

          <MDSnackbar
            color={noticolor}
            icon="notifications"
            title="Youtube Slider"
            content={message}
            dateTime="Just now"
            open={notification}
          />
        </MDBox>
      </DashboardLayout>
    );
  }
}
